import React, { useState } from 'react';
import image from './LOGO.jpeg';
import './App.css';

// const healthcareLogo = 'https://img.freepik.com/premium-vector/health-care-medical-logo-vector-design_990473-2554.jpg';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="App">
      {/* Navbar */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo-container">
            <img src={image} className="nav-logo" alt="Healthcare Logo" />
            <div className="nav-brand-container">
              <span className="nav-brand">HealthCare</span>
              <span className="nav-sub-brand">NETWORK</span>
            </div>
          </div>
          <div className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}>
            <a href="#services" className="nav-link" onClick={() => setIsMenuOpen(false)}>Services</a>
            <a href="#about" className="nav-link" onClick={() => setIsMenuOpen(false)}>About Us</a>
            <a href="#contact" className="nav-link" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
            <button className="nav-login-btn">Login</button>
          </div>
          <div className={`mobile-menu-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>

      {/* Coming Soon Section */}
      <main className="coming-soon-container">
        <div className="background-animation">
          <div className="floating-shape shape-1"></div>
          <div className="floating-shape shape-2"></div>
          <div className="floating-shape shape-3"></div>
          <div className="floating-shape shape-4"></div>
        </div>
        
        <div className="content-wrapper">
          <div className="glass-card">
            <h1 className="coming-soon-title">Coming Soon</h1>
            <p className="coming-soon-subtitle">
              Connecting Hospitals <span className="red-plus">+</span> Resources
            </p>
            <p style={{ color: 'black' }}>
<b>HealthCare Network India</b> is a platform facilitating affordable, accessible, and transparent healthcare across India by connecting patients with top hospitals, local health centers, and services like teleconsultation, medical travel, and health insurance. It features quality hospitals network in each state with over 200+ corporate hospitals, it's network, diagnostic points and provides accredited fellowships.<br></br> 

Contact us at : info@healthcarenetwork.in</p>
            <div className="pulse-indicator">
              <div className="pulse-dot"></div>
            </div>
            
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
